module.exports = __webpack_public_path__ + "img/3.a92f6588.jpg";